import initialState from './initialState';
import _ from 'lodash';

export class StateLoader {
    loadState() {
        let serializedState = localStorage.getItem('bfi_state');

        if (serializedState === null) {
            return this.initializeState();
        }

        return _.merge(this.initializeState(), JSON.parse(serializedState));
    }

    saveState(state) {
        let serializedState = JSON.stringify(state);
        localStorage.setItem('bfi_state', serializedState);
    }

    initializeState() {
        return initialState;
    }
}
